export default "/bundles/assets/alert_8a39c24fd3ac411d2f19c53f7d942f05.png";